import axios from "axios"
import { NextResponse } from "next/server"
import {
  buildAdminAjaxUrl,
  resolveWordPressOrigin,
  type SendTriiboOtpInput,
  type SendTriiboOtpResponse,
} from "@/api/auth"
import { env } from "@/env"

const toUrlEncodedBody = (input: Record<string, string>): URLSearchParams => {
  const payload = new URLSearchParams()

  for (const [key, value] of Object.entries(input)) {
    payload.set(key, value)
  }

  return payload
}

export const POST = async (request: Request) => {
  const body = (await request.json()) as SendTriiboOtpInput
  const origin = resolveWordPressOrigin(env.WP_API_URL)
  const endpoint = buildAdminAjaxUrl(origin)

  try {
    const { data } = await axios.post<SendTriiboOtpResponse>(
      endpoint,
      toUrlEncodedBody({
        action: "tal_auth_sms",
        cellphone: body.cellphone ?? "",
        email: body.email ?? "",
        type: body.type,
      }),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )

    return NextResponse.json(data)
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.data) {
      return NextResponse.json(error.response.data, {
        status: error.response.status,
      })
    }

    return NextResponse.json(
      {
        success: false,
        error: {
          errorCode: 500,
          message: "Falha ao enviar codigo OTP.",
        },
      },
      { status: 500 }
    )
  }
}
